import React from "react";

const teamMembers = [
  {
    name: "Maxwell Ullman",
    title: "Principal",
    phone: "858-243-3178",
    email: "mullman@growthproperty.us",
    bio: "With over 10 years of real estate experience, Maxwell Ullman brings with him an intimate knowledge of the retail landscape. After graduating from NYU, Mr. Ullman started his career at Douglas Elliman as a residential broker before moving to Compass where he was instrumental in sales of over $100M and became the Director of Leasing for a major NYC landlord leasing over $20m in aggregate lease value. Subsequently, Maxwell shifted focus to concentrate solely on commercial investment sales representing The Niki Group, a large private retail fund, with acquisitions where he identified and closed on highly strategic assets spanning 7 across states.",
    image: "/images/team/max.jpeg",
  },
  {
    name: "Daniyel Cohen",
    title: "Principal",
    phone: "617-817-9316",
    email: "dcohen@growthproperty.us",
    bio: "Daniyel Cohen started his career as a credit risk analyst at UBS on the real estate finance team focusing on CMBS and balance sheet loans. After his time at UBS, Daniyel moved on to become one of the top performing retail leasing brokers in New York City at Winick Realty Group, one of New York’s prominent brokerages. Having leased over 1.5 million square feet, Daniyel’s experience at Winick Realty Group has led him to form significant relationships with the directors of real estate representing a number of the nation’s top retail tenants. Daniyel’s keen sense and significant retail background has enabled him to identify strong performing retail locations and negotiate creative leasing structures.",
    image: "/images/team/dani.jpg", 
  },
];

class Team extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <div className="page-image" />
        <div className="row container section">
          <h5>Team</h5>
          <br />
          <h6>Partners</h6>
          {teamMembers.map((member, idx) => {
            return (
              <div
                className={idx > 0 ? "col s12 offset-m1 m5 offset-l1 l5" : "col s12 m5 l5"}
                key={idx}
              >
                <p className="bio">
                  <img alt={member.name} src={member.image} className="team-img" />
                  <strong>{member.name} –</strong>
                  &nbsp;
                  <em>{member.title}</em>
                  <br />
                  <div className="section" />
                  {member.bio}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default Team;
